(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "axios"], factory);
	else if(typeof exports === 'object')
		exports["hrzz/home/homepage/main/index"] = factory(require("React"), require("ReactDOM"), require("axios"));
	else
		root["hrzz/home/homepage/main/index"] = factory(root["React"], root["ReactDOM"], root["axios"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__121__) {
return 